import { PaneArea } from '../../types/shared'
import ScaledText from '../canvas/scaled_text'
import { ITextAttrs } from '../canvas/text'
import { StyleDialogOpener } from '../modals/element_style'
import ElementModel from '../models/element'
import PaneModel from '../models/pane'

type Area = PaneArea
type Attrs = ITextAttrs
type PartialAttrs = Partial<Attrs>

class ScaledTextCreator extends ScaledText<Attrs> {
  isCreator = true
  openStyleDialog: StyleDialogOpener<ScaledTextCreator>

  constructor(
    startArea: Area,
    values: PartialAttrs,
    model: PaneModel,
    openStyleDialog: StyleDialogOpener<ScaledTextCreator>,
    toolsCallback: () => void
  ) {
    super(values, model)

    this.openStyleDialog = openStyleDialog

    this.attrs.x = startArea.x
    this.attrs.y = startArea.y
    this.attrs.text = ''
    this.toolsCallback = toolsCallback

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }

  onMouseUp() {
    this.isCreatorDialogOpen = true
    this.openStyleDialog(
      this,
      (values) => {
        this.set(values)
        this.release()
        this.replaceMyself(ScaledText.fromObject<ScaledText>(this.attrs, this.model))
        this.toolsCallback()
      },
      () => {
        const instance = ElementModel.findByAttribute<ElementModel>('instance', this)
        instance?.destroy()
      }
    )
  }
}

export default ScaledTextCreator
